/* ==== AUTOCOMPLETE ADDRESS ==== */

// This code uses the Places Autocomplete widget to:
// 1. Help the user select a place
// 2. Retrieve the address components associated with that place
// 3. Populate the form fields with those address components.
// This code requires the Places library, Maps JavaScript API.
// Include the libraries=places parameter when you first load the API.
// For example: <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">

function initAutocomplete() {
  var autocompleteAddressFields = document.getElementsByClassName('autocomplete-address__address');
  var autocomplete = [];

  if (autocompleteAddressFields.length) {
    for (var i = 0; i < autocompleteAddressFields.length; i++) {
      // Create the autocomplete object, restricting the search predictions to addresses in Canada.
      autocomplete.push(new google.maps.places.Autocomplete(autocompleteAddressFields[i], {
        componentRestrictions: { country: ['ca'] },
        fields: ['address_components', 'geometry'],
        types: ['address'],
      }));

      autocomplete[i].inputId = autocompleteAddressFields[i].id;
      autocompleteAddressFields[i].previousSibling.previousSibling.classList.add('input-focus');

      // When the user selects an address from the drop-down, populate the address fields in the form.
      google.maps.event.addListener(autocomplete[i], 'place_changed', function () {
        // Get the place details from the autocomplete object.
        var place = this.getPlace();

        if (place) {
          var address = '';
          var addressContainer = document.querySelector('#' + this.inputId).closest('.autocomplete-address');
          var addressField = document.querySelector('#' + this.inputId);
          var cityField = addressContainer.querySelector('.autocomplete-address__city');
          var provinceField = addressContainer.querySelector('.autocomplete-address__province');
          var postalCodeField = addressContainer.querySelector('.autocomplete-address__postal-code');

          // Get each component of the address from the place details, 
          // and then fill-in the corresponding field on the form.
          for (var component of place.address_components) {
            var componentType = component.types[0];

            switch (componentType) {
              case 'street_number':
              address = `${component.long_name} ${address}`;
              break;

              case 'route':
              address += component.short_name;
              break;

              case 'locality':
              cityField.value = component.long_name;
              cityField.previousSibling.previousSibling.classList.add('input-focus');
              break;

              case 'administrative_area_level_1':
              provinceField.value = component.long_name;
              provinceField.previousSibling.previousSibling.classList.add('input-focus');
              break;

              case 'postal_code':
              postalCodeField.value = component.long_name;
              postalCodeField.previousSibling.previousSibling.classList.add('input-focus');
              break;
            }
          }

          addressField.value = address;
        }
      });
    }
  }
}

window.initAutocomplete = initAutocomplete;